import api from "./api";

export type AttendanceStatus = "clock_in" | "break" | "resume_work" | "clock_out";

export interface AttendanceResponse {
    success: boolean;
    message: string;
    data?: any;
}

/**
 * Process employee attendance status change.
 * @param status The status to set (clock_in, break, resume_work, clock_out)
 */
export const processAttendance = async (status: AttendanceStatus): Promise<AttendanceResponse> => {
    try {
        const response = await api.post<AttendanceResponse>(`/admin/timesheets/attendance/${status}`);
        return response.data;
    } catch (error: any) {
        console.error(`Error processing attendance ${status}:`, error);
        throw error?.response?.data || error;
    }
};

/**
 * Fetch the current attendance status for the logged-in employee.
 * Note: If the backend doesn't have a direct "get status" endpoint, 
 * we might need to rely on the latest timesheet entry or local persistence.
 */
export const getCurrentAttendanceStatus = async (): Promise<any> => {
    try {
        // Assuming there's a GET endpoint or we check the today's timesheet
        const response = await api.get("/admin/timesheets/attendance/status");
        return response.data;
    } catch (error) {
        console.warn("Failed to fetch attendance status, might not be implemented:", error);
        return null;
    }
};
